import type { GetInstructorsResult } from '@features/instructors/api/get-instructors/getInstructors.types';
import type { InstructorsTableDataState } from '@features/instructors/types/instructors-table-data-state.types';

export const INITIAL_INSTRUCTORS_DATA: GetInstructorsResult = {
  elements: [],
  total: 0,
};

export const INITIAL_DATA_STATE: InstructorsTableDataState = {
  pageSize: 25,
  pageIndex: 0,
  sortBy: 'fullName',
  sortDirection: 'asc',
};
